// extracted by mini-css-extract-plugin
export var container1 = "promoMagazin-module--container1--3Jd4c";
export var container2 = "promoMagazin-module--container2--23TZf";
export var container3 = "promoMagazin-module--container3--V-Wwy";
export var image = "promoMagazin-module--image--318vn";
export var bodyPreview = "promoMagazin-module--bodyPreview--2E8v9";
export var mag = "promoMagazin-module--mag--28TkO";
export var title = "promoMagazin-module--title--pdhxK";
export var more = "promoMagazin-module--more--1Ndge";
export var arrow = "promoMagazin-module--arrow--2nlOb";